export const Api = {
  config: {
    prefix: "/api/codex/v1",
  },
};
